import { Grid, Typography } from '@mui/material';
import FieldText from '../../../../../components/general/fields/fieldText';
import { useAccountAddress } from './hook';
import { AccountAddressProps } from './props';
import AutocompleteField from '../../../../../components/general/fields/autocompleteField';

export const AccountAddress = (props: AccountAddressProps) => {
    const { formik, cities, types1, letters } = useAccountAddress(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12}>
                <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                    Dirección
                </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={cities}
                    label="Ciudad dirección"
                    name="city"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.city}
                    errors={formik.errors.city}
                    value={formik.values.city}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('city', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={2}>
                <AutocompleteField
                    data={types1}
                    label="Tipo 1"
                    name="type1"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.type1}
                    errors={formik.errors.type1}
                    value={formik.values.type1}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('type1', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={2}>
                <FieldText
                    label="Tipo 2"
                    name="type2"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.type2}
                    errors={formik.errors.type2}
                    value={formik.values.type2}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={2}>
                <FieldText
                    label="Número"
                    name="number1"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.number1}
                    errors={formik.errors.number1}
                    value={formik.values.number1}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={2}>
                <AutocompleteField
                    data={letters}
                    label="Letra"
                    name="letter1"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.letter1}
                    errors={formik.errors.letter1}
                    value={formik.values.letter1}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('letter1', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={2}>
                <AutocompleteField
                    data={letters}
                    label="Letra"
                    name="letter2"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.letter2}
                    errors={formik.errors.letter2}
                    value={formik.values.letter2}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('letter2', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={2}>
                <FieldText
                    label="Cuadrante"
                    name="quadrant1"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.quadrant1}
                    errors={formik.errors.quadrant1}
                    value={formik.values.quadrant1}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={2}>
                <FieldText
                    label="Número"
                    name="number2"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.number2}
                    errors={formik.errors.number2}
                    value={formik.values.number2}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={2}>
                <AutocompleteField
                    data={letters}
                    label="Letra"
                    name="letter3"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.letter3}
                    errors={formik.errors.letter3}
                    value={formik.values.letter3}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('letter3', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={2}>
                <AutocompleteField
                    data={letters}
                    label="Letra"
                    name="letter4"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.letter4}
                    errors={formik.errors.letter4}
                    value={formik.values.letter4}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('letter4', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={2}>
                <FieldText
                    label="Cuadrante"
                    name="quadrant2"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.quadrant2}
                    errors={formik.errors.quadrant2}
                    value={formik.values.quadrant2}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={2}>
                <FieldText
                    label="Número"
                    name="number3"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.number3}
                    errors={formik.errors.number3}
                    value={formik.values.number3}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={2}>
                <FieldText
                    label="Cuadrante"
                    name="quadrant3"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.quadrant3}
                    errors={formik.errors.quadrant3}
                    value={formik.values.quadrant3}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Complemento"
                    name="complement"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.complement}
                    errors={formik.errors.complement}
                    value={formik.values.complement}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12}>
                <FieldText
                    label="Dirección georeferenciación"
                    name="address"
                    size="small"
                    disabled
                    onBlur={formik.handleBlur}
                    touched={formik.touched.address}
                    errors={formik.errors.address}
                    value={formik.values.address}
                />
            </Grid>
        </Grid>
    );
};
